import { useState } from 'react';
import get from 'lodash/get';
import { me, getTeacherInfo } from 'legacy/src/queries';
import {
  setTeacherClasses,
  setTeacherSubjects,
  setTeacherNav,
} from 'legacy/src/components/impersonating/state/actions';
import { LC_CONSTANTS } from 'legacy/src/components/impersonating/utils/constants';

export default (props) => {
  const { client, dispatch } = props;
  const [classes, setClasses] = useState([]);
  const [navData, setNavData] = useState([]);

  const getTeacherData = async ({ subjectId }) => {
    const currentEducationPeriod = Number.parseInt(
      window.localStorage.getItem(LC_CONSTANTS.EDUCATION_PERIOD),
      10,
    );
    const mePromise = client
      .query({
        query: me,
      })
      .then((response) => {
        const teacherSubjects = get(response, 'data.teacherSubjects', []);
        const currentSubject =
          teacherSubjects.find(({ id }) => id === subjectId) || {};
        const teacherClasses = (currentSubject.classes || []).filter(
          ({ educationPeriod }) => educationPeriod === currentEducationPeriod,
        );
        setClasses(teacherClasses);
        setTeacherClasses(dispatch, teacherClasses);
        setTeacherSubjects(dispatch, teacherSubjects);

        return response;
      });

    const teacherInfoPromise = client
      .query({
        query: getTeacherInfo,
        variables: {
          id: subjectId,
          educationPeriod: currentEducationPeriod,
        },
      })
      .then((response) => {
        const nav = get(response, 'data.teacherSubject.nav', []);
        setNavData(nav);
        setTeacherNav(dispatch, nav);

        return response;
      });

    return Promise.all([mePromise, teacherInfoPromise]);
  };

  const data = {
    classes,
    navData,
  };

  return [data, getTeacherData];
};
